
import *as actionTypes from '../constants/cartConstant';


export const cartReducer=(state={cartItems:[]},action)=>{

    switch(action.type)
    {
        case actionTypes.ADD_TO_CART:
            const  item=action.payload;
            const exist=state.cartItems.find(product=>product.id===item.id);

            if(exist)
            {
              return {...state,cartItems:state.cartItems.map(data=>data.product===exist.product?item:data)}
            }else{
                return {...state,cartItems:[...state.cartItems,item]}


            }
        case actionTypes.REMOVE_FROM_CART:
             return {...state,cartItems:state.cartItems.filter(product=>product.id!==action.payload)}  
             
        
       case actionTypes.UPDATE_CART_ITEM_QUANTITY:
    const { itemId, quantity } = action.payload;
    const updatedCartItems = state.cartItems.map(item => {
      if (item.id === itemId) {
        return {
          ...item,
          quantity: quantity
        };
      }
      return item;
    });
    return {
      ...state,
      cartItems: updatedCartItems
    };
    default:
            return state;
    }
}